import React from 'react';
import ToastContainer from '@components/toast/ToastContainer';
import CoachingPlaylistContainer from 'components/coaching/CoachingPlaylistContainer';
import {RouterLocation} from '@store/@types/util/ReactRouter';
import AuthRefresh from 'components/init/AuthRefresh';
import hasFlag from 'utils/hasFlag';
import {featureFlags} from 'utils/const';
import NylasIntegrationStore from '@store/nylas/NylasIntegrationStore';
import NylasIntegrationActions from '@store/nylas/NylasIntegrationActions';

interface GlobalComponentsProps {
  location: RouterLocation;
}

/**
 * Components rendered at the app level, so they can be accessed by any page
 *
 * These are only rendered post-login
 */
export const GlobalComponents: React.FC<GlobalComponentsProps> = props => {
  const {environment} = NylasIntegrationStore.getState();
  if (!environment) {
    NylasIntegrationActions.fetchNylasEnvironment();
  }
  return (
    <>
      <ToastContainer />
      <CoachingPlaylistContainer location={props.location} />
      {hasFlag(featureFlags.logoutTimer) && <AuthRefresh />}
    </>
  );
};
